import { AttributeTemplate } from "@/models/api/administration/servicesAndAttributes/AttributeTemplate";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class ServiceTypeAttributeTemplate {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsNumber()
  attributeTemplateId!: number;
  @Expose()
  @IsNumber()
  ordinal!: number;
  @Expose()
  @IsOptional()
  @IsString()
  defaultValue!: string | null;
  @Expose()
  @IsBoolean()
  isRequired!: boolean;
  @Expose()
  @IsBoolean()
  isPrintable!: boolean;
  @Expose()
  @Type(() => AttributeTemplate)
  @ValidateNested()
  attributeTemplate!: AttributeTemplate;
}
